import { render, staticRenderFns } from "./ProfitCenterForm.vue?vue&type=template&id=72d175b4&scoped=true&lang=pug&"
import script from "./ProfitCenterForm.vue?vue&type=script&lang=ts&"
export * from "./ProfitCenterForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d175b4",
  null
  
)

export default component.exports